/**
 * @generated SignedSource<<1e1df174e66d4f07c57370cfa07f78e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RedemptionFacetsRefetchQuery$variables = {
  id: string;
};
export type RedemptionFacetsRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"RedemptionFacets_redemptionTypes">;
  } | null;
};
export type RedemptionFacetsRefetchQuery = {
  response: RedemptionFacetsRefetchQuery$data;
  variables: RedemptionFacetsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RedemptionFacetsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RedemptionFacets_redemptionTypes"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RedemptionFacetsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RedemptionType",
                "kind": "LinkedField",
                "name": "types",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "RedemptionTypes",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "546ceafac92e6a577286720b85175fe8",
    "id": null,
    "metadata": {},
    "name": "RedemptionFacetsRefetchQuery",
    "operationKind": "query",
    "text": "query RedemptionFacetsRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...RedemptionFacets_redemptionTypes\n    id\n  }\n}\n\nfragment RedemptionFacets_redemptionTypes on RedemptionTypes {\n  types {\n    id\n    name\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "2aa2650cd21e8ba28f21a573279cec8a";

export default node;
